<template>
	<span>
		{{text}}
	</span>
</template>

<script>


	export default {
		name: "locale-text",
		props: {
			page: null,
			name: null,
		},
		computed: {
			text() {
				return this.$t(`pages.${this.page}.${this.name}`);
			}
		}
	};
</script>

<style scoped>

</style>
